"use strict";

exports.__esModule = true;
var INIT = exports.INIT = {
  pending: false,
  fulfilled: false,
  rejected: false
};

var PENDING = exports.PENDING = {
  pending: true,
  fulfilled: false,
  rejected: false
};

var FULFILLED = exports.FULFILLED = {
  pending: false,
  fulfilled: true,
  rejected: false
};

var REJECTED = exports.REJECTED = {
  pending: false,
  fulfilled: false,
  rejected: true
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-redux-fetch/lib/constants/request.js
// module id = 73
// module chunks = 0